import Widget from '@Components/Shared/Widgets/Widget';
import { useWindowSize } from '@Components/Utilities/WindowSize';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { getDistinct, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';

const ShippingEstimate = loadable(() => import('@Components/Shared/ShippingEstimate'));

const WidgetList = (props) => {
    const windowSize = useWindowSize();

    const getHaulerWidgetButton = () => {
        return (
            ((props.pageType && props.pageType == 'detail') && props.shippingEstimateData?.estimateDisplay) ?
                <ShippingEstimate
                    {...props.shippingEstimateData}
                    ImageURL={props.shippingEstimateImageUrl}
                    blockName={props.pageType}
                />
                :
                <Widget
                    showWidget={props.ShowHaulerWidget}
                    url={props.HaulerWidgetURL}
                    imageSource={!windowSize.isMobile && props.HaulerImageURL}
                    label={translator.translate('sandhills.tradesites.mvc.getshippingquotes')}
                    className='shipping listing-widget__shipping'
                    IsRedesign={props.IsRedesign}
                />
        );
    };

    const routes = useRecoilValue(atoms.routes);

    const saveAction = (e) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': 'purchaseToday',
                'manufacturers': [props.Manufacturer],
                'models': [props.Model],
                'listingTypes': [props.ListingType],
                'categoryIDs': getDistinct([props.CategoryId, props.AltCategoryId]),
                'listingIDs': [props.ListingID],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });
    };

    return (
        <div className={'listing-widgets listing-widgets' + '-' + props.pageType}>
            {windowSize.isMobile ?
                <>
                    <Widget
                        showWidget={props.ShowLenderWidget}
                        url={props.LenderWidgetURL}
                        label={translator.translate('sandhills.tradesites.mvc.applyforfinancing')}
                        className={'financing listing-widget__financing ' + props.LenderCompanyName}
                        saveAction={saveAction}
                        IsRedesign={props.IsRedesign}
                    />
                    <Widget
                        showWidget={props.ShowCostCalculatorWidget}
                        url={props.CostCalculatorWidgetURL}
                        label={translator.translate('sandhills.operatingcosts')}
                        className='cost-calculator listing-widget__cost-calculator'
                        IsRedesign={props.IsRedesign}
                    />
                    <Widget
                        showWidget={props.ShowInsuranceWidget}
                        url={props.InsuranceWidgetURL}
                        label={translator.translate('sandhills.getinsurance')}
                        className='insurance listing-widget__insurance'
                        IsRedesign={props.IsRedesign}
                    />
                    {getHaulerWidgetButton()}
                    <Widget
                        showWidget={props.ShowEscrowWidget}
                        url={props.EscrowWidgetURL}
                        label={translator.translate('sandhills.escrow')}
                        className='escrow listing-widget__escrow'
                        IsRedesign={props.IsRedesign}
                    />
                </>
                :
                <>
                    {props.IsRedesign ?
                        <>
                            <Widget
                                showWidget={props.ShowLenderWidget}
                                url={props.LenderWidgetURL}
                                imageSource={props.LenderImageURL}
                                label={translator.translate('sandhills.tradesites.mvc.applyforfinancing')}
                                className={'financing listing-widget__financing ' + props.LenderCompanyName}
                                saveAction={saveAction}
                                IsRedesign={props.IsRedesign}
                            />
                            <Widget
                                showWidget={props.ShowEscrowWidget}
                                url={props.EscrowWidgetURL}
                                label={translator.translate('sandhills.escrow')}
                                className='escrow listing-widget__escrow'
                                IsRedesign={props.IsRedesign}
                            />
                            {getHaulerWidgetButton()}
                            <Widget
                                showWidget={props.ShowInsuranceWidget}
                                url={props.InsuranceWidgetURL}
                                label={translator.translate('sandhills.getinsurance')}
                                className='insurance listing-widget__insurance'
                                IsRedesign={props.IsRedesign}
                            />
                            <Widget
                                showWidget={props.ShowCostCalculatorWidget}
                                url={props.CostCalculatorWidgetURL}
                                label={translator.translate('sandhills.operatingcosts')}
                                className='cost-calculator listing-widget__cost-calculator'
                                IsRedesign={props.IsRedesign}
                            />
                        </>
                        :
                        <>
                            <Widget
                                showWidget={props.ShowEscrowWidget}
                                url={props.EscrowWidgetURL}
                                label={translator.translate('sandhills.escrow')}
                                className='escrow listing-widget__escrow'
                                IsRedesign={props.IsRedesign}
                            />
                            {getHaulerWidgetButton()}
                            <Widget
                                showWidget={props.ShowInsuranceWidget}
                                url={props.InsuranceWidgetURL}
                                label={translator.translate('sandhills.getinsurance')}
                                className='insurance listing-widget__insurance'
                                IsRedesign={props.IsRedesign}
                            />
                            <Widget
                                showWidget={props.ShowCostCalculatorWidget}
                                url={props.CostCalculatorWidgetURL}
                                label={translator.translate('sandhills.operatingcosts')}
                                className='cost-calculator listing-widget__cost-calculator'
                                IsRedesign={props.IsRedesign}
                            />
                            <Widget
                                showWidget={props.ShowLenderWidget}
                                url={props.LenderWidgetURL}
                                imageSource={props.LenderImageURL}
                                label={translator.translate('sandhills.tradesites.mvc.applyforfinancing')}
                                className={'financing listing-widget__financing ' + props.LenderCompanyName}
                                saveAction={saveAction}
                                IsRedesign={props.IsRedesign}
                            />
                        </>
                    }
                </>}
        </div>

    );
};

export default WidgetList;